module.exports = __webpack_public_path__ + "static/media/rishabhD.307725a9.jpeg";